import { useEffect, useMemo, useState } from "react";
import SettingsPageBlock from "./SettingsPageBlock";
import CompanySettingsDropdown from "./companysettingsdrodown/CompanySettingsDropdown";
import { useSelector } from "react-redux";
import "./mspsettingsv2.scss";
import "./companysettings.scss";
import CompanySettingsHeader from "./CompanySettingsHeader";
import { CallToast } from "../../PriceCalculator/modals/CustomToast";
import DropdownSectionsSelect from "../../Common/dropdown-sections-select/dropdown-sections-select.component";
import CompanyTimeZoneDropDown from "./companysettingsdrodown/CompanyTimeZoneDropDown";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import useUserDetails from "../../../hooks/user-details.hook";
import useActions from "../../../hooks/service-actions.hook";
import { CompanySettingsEffectActions } from "../../../common/services/company-settings/company-settings.service";
import { useEntity } from "../../../hooks/use-entity.hook";
import { Entities } from "../../../common/store/entities/entities.enum";
import { useAuth } from "../../context/Auth";
import { useDispatch } from "react-redux";
import useUpdateEmailPhone from "./update-email-phone.data";
import { setcompany } from "../../../redux/companyState/actions";
import { CustomGetApi, getAPIData, postRequest } from "../../../Utils/commonApi";
import { API_DOMENS } from "../../../constants/apis.constants";
import { getAccessStateValue } from "../../App/App";
import stringUtils from "../../../Utils/string.utils";
import TemporarySupportAccessModal from "./TemporarySupportAccessModal";
import ManageClientNotificationsModal from "./companySettingsModals/ManageClientNotificationsModal";
import TaxesModal from "./companySettingsModals/taxes.modal";
import SendCopyMSPEmailsModal from "./companySettingsModals/SendCopyMSPEmailsModal";
import SendCopyClientEmailsModal from "./companySettingsModals/SendCopyClientEmailsModal";
import ChangeAddressModal from "./companySettingsModals/ChangeAddressModal";
import { UpdateNameModal } from "./companySettingsModals/UpdateNameModal";
import UpdateTextValueModal from "./companySettingsModals/update-text-value.modal";
import { CustomDeleteModal } from "../../DeleteModal/DeleteModal";
import ImageCropperModal from "./companySettingsModals/ImageCropperModal";
import { getModalHeaderAndBody } from "./companySettingsModals/SubscriptionsV2";
import { SubscriptionSettingsLine } from "../../distributors/distributor-info-pages/distributor-settings/subscription-settings-line/subscription-settings-line";

const CompanySettings = ({ isView = false, isDistributorView = false }) => {
  const { clientId: clientIdfromDetails, userDetails } = useUserDetails();

  const clientId = clientIdfromDetails;
  const { getCompanySettings } = useActions(CompanySettingsEffectActions);
  const { entityData: companySettings } = useEntity({ entityType: Entities.CompanySettings, entityId: clientId });

  const { authTokens } = useAuth();
  const [pageData, setPageData] = useState({});
  const dispatch = useDispatch();
  const [countryList, setCountryList] = useState([]);
  const companyDetails = useSelector((state) => state?.company?.companyDetail);
  const [industry, setIndustry] = useState();
  const [employee, setEmployee] = useState();
  const [timezone, setTimezone] = useState();
  const [country, setCountry] = useState();
  const [localisation, setLocalisation] = useState();
  const [taxRates, setTaxRates] = useState([]);
  const [updateNameModal, setUpdateNameModal] = useState(false);
  const [addressModal, setAddressModal] = useState(false);
  const [cropperModal, setCropperModal] = useState(false);
  const [manageEmalNotificationsModal, setManageEmalNotificationsModal] = useState(false);
  const [taxesModal, setTaxesModal] = useState(false);
  const [sendCopyMSPEmailsModal, setSendCopyMSPEmailsModal] = useState(false);
  const [sendCopyClientEmailsModal, setSendCopyClientEmailsModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [mainPageLoading, setMainPageLoading] = useState(false);
  const [showTemporarySupportAccessModal, setShowTemporarySupportAccessModal] = useState(false);
  const [deleteModalData, setDeleteModalData] = useState({
    show: false,
    deleteHeaderText: "Are you sure ?",
    deleteBodyText: "Do you want to delete this policy ?",
    deleteButtonClass: "",
    deleteType: "deleteCyberInsurancePolicy",
    processingText: "",
    deleteButtonText: "",
  });
  const [textValueModal, setTextValueModal] = useState({
    show: false,
    title: "",
    inputLabel: "",
    placeholder: "",
    defaultValue: "",
    handleOnChange: () => { },
    hideModal: () => {
      setTextValueModal((prev) => ({
        ...prev,
        show: false,
      }));
    }
  });
  const { isLoading: isEmailPhoneLoading, updateEmailPhoneHandler } = useUpdateEmailPhone({
    refreshData: getGeneralInfo,
  });

  const hasSystemSettingsAccess = useMemo(
    () => !isView && getAccessStateValue("AccessState_MSP_System_Settings") >= 3,
    [isView]
  );

  const hideCropperModal = () => {
    setCropperModal(false);
  };
  const showCropperModal = () => {
    setCropperModal(true);
  };
  const showUpdateNameModal = () => {
    setUpdateNameModal(true);
  };
  const hideUpdateNameModal = () => {
    setUpdateNameModal(false);
  };

  const showAddressModal = () => {
    setAddressModal(true);
  };
  const hideAddressModal = () => {
    setAddressModal(false);
  };

  async function getGeneralInfo() {
    getCompanySettings({ clientId });
  }
  
  useEffect(() => {
    getCountryList();
    setMainPageLoading(true);
    getGeneralInfo();
  }, []);

  useEffect(() => {
    if (!companySettings) return;
    setPageData(companySettings);
    setMainPageLoading(false);
    dispatch(setcompany(companySettings));
    setIndustry(
      companySettings?.DDLMembers &&
      companySettings?.DDLMembers[0]?.DDLMemberList?.filter(
        (val) => val.DDLText == companySettings.Industry
      )[0]
    );
    setEmployee(
      companySettings?.DDLMembers &&
      companySettings?.DDLMembers[1]?.DDLMemberList?.filter(
        (val) => val.DDLText == companySettings.UserCount
      )[0]
    );
    setTimezone(
      companySettings?.DDLMembers &&
      companySettings?.DDLMembers[2]?.DDLMemberList?.filter(
        (val) => val.DDLText == companySettings.Timezone
      )[0]
    );
    setLocalisation(
      companySettings?.DDLMembers &&
      companySettings?.DDLMembers[3]?.DDLMemberList?.filter(
        (val) => val.DDLId == companySettings.Localisation
      )[0]
    );
    setCountry({
      objId: parseInt(companySettings?.Country),
      name: companySettings?.Country_Text,
    });
    setTaxRates(companySettings?.TaxRates);
    setSelectedImage(companySettings?.LogoURL);
  }, [companySettings]);

  async function getCountryList() {
    await CustomGetApi(`CC_API/GetCountries?IsSimpleSort=0`)
      .then((response) => {
        if (response?.mr?.Success) {
          setCountryList(response?.detail);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function updateClientLicence(kwargs) {
    await getAPIData("523", authTokens, {
      optionEnum1: kwargs?.clientId,
      optionEnum2: kwargs?.Key,
    }, API_DOMENS.CC_API).then((response) => {
    });
  }

  function handleOnChange(value, fieldName) {
    return new Promise((resolve, reject) => {
      const inputs = {
        NotificationName: fieldName,
        NotificationValue: value,
        SettingOwner: companyDetails.objId_SettingOwner,
        OwnerType: 0,
      };

      postRequest(authTokens, "SubmitNotificationSettings", inputs, API_DOMENS.CC_API)
        .then((response) => {
          resolve(response);
          getGeneralInfo();
          if (response.Success) {
            CallToast("Updated successfully", false, false, "v2style");
          } else {
            CallToast("Something went wrong", false, false, "v2style");
          }
        })
        .catch((err) => {
          reject(err);
          CallToast("Something went wrong", false, false, "v2style");
        });
    });
  }

  const companyInfoFields = useMemo(() => {
    const allFields = [{
              label: 'Company Name',
              value: pageData?.CompanyName,
              show: true,
            },
            {
              label: 'MSP Name',
              value: pageData?.MSPName,
              show: true,
            },
            {
              label: 'Industry',
              show: true,
              children: <div className="industry-drop">
                <CompanySettingsDropdown
                  disabled={!hasSystemSettingsAccess}
                  disabledIcon={!hasSystemSettingsAccess}
                  fieldId={"DDLId"}
                  fieldValue={"DDLText"}
                  selected={industry}
                  placeholder="Choose..."
                  onClick={(id, val) => {
                    setIndustry({ DDLId: id, DDLText: val });
                    handleOnChange(id, "SOindustry").then((res) => { }).catch((err) => console.log(err));
                  }}
                  data={companyDetails?.DDLMembers && companyDetails?.DDLMembers[0].DDLMemberList}
                />
              </div>
            },
            {
              label: 'Employees',
              show: true,
              children: <div className="employee-drop">
                <CompanySettingsDropdown
                  disabled={!hasSystemSettingsAccess}
                  disabledIcon={!hasSystemSettingsAccess}
                  fieldId={"DDLId"}
                  fieldValue={"DDLText"}
                  selected={employee}
                  placeholder="Choose..."
                  onClick={(id, val) => {
                    handleOnChange(id, "SOusers");
                    setEmployee({ DDLId: id, DDLText: val });
                  }}
                  data={companyDetails?.DDLMembers && companyDetails?.DDLMembers[1].DDLMemberList}
                />
              </div>
            },
            {
              label: 'Address',
              show: true,
              children: <div onClick={() => {
                if (!hasSystemSettingsAccess) return;
                setAddressModal(true);
              }} className="d-flex align-items-center justify-content-end">
                <div className="text-ellipsis" style={{ width: "90%" }}>
                  <span className="name">
                    {companyDetails?.Address1 ? `${companyDetails?.Address1}, ` : ""}
                    {companyDetails?.Address2 ? `${companyDetails?.Address2}, ` : ""}
                    {companyDetails?.Address3 ? `${companyDetails?.Address3}, ` : ""}
                    {companyDetails?.County ? `${companyDetails?.County}, ` : ""}
                    {companyDetails?.Postcode ? `${companyDetails?.Postcode}` : ""}
                  </span>
                </div>
                {hasSystemSettingsAccess ? (
                  <img alt="" src="/images/chevron-right.svg" className="details-arrow" />
                ) : (
                  <img width={14} height={14} alt="" src="/images/attack-surface/small-lock.svg" className="mx-2" />
                )}
              </div>
            },
            {
              label: 'Company Type',
              value: pageData?.companyType,
              show: true,
            },
            {
              label: 'License',
              show: true,
              children: <div className="d-flex align-items-center justify-content-end">
                <div style={{ paddingRight: '6px' }}>
                  <DropdownSectionsSelect
                    selected={pageData?.selectedLicenseType}
                    fieldId={"Value"}
                    fieldValue={"Value"}
                    dropDownMenuClass="z-Index-1 align-right"
                    itemMenuClass="pr-4"
                    onItemSelected={(item) => {
                      if (!hasSystemSettingsAccess) {
                        return;
                      }
                      if (!pageData.selectedLicenseType) {
                        setPageData(prev => ({ ...prev, selectedLicenseType: item }));
                        return;
                      }
                      if (pageData.selectedLicenseType?.Value?.trim().split(" ")[0].toLowerCase() === item?.Value?.trim().split(" ")[0].toLowerCase()) {
                        return;
                      }
                      let modalBody = getModalHeaderAndBody(
                        userDetails?.name,
                        pageData.selectedLicenseType?.Value?.trim().split(" ")[0].toLowerCase(),
                        item?.Value?.trim().split(" ")[0].toLowerCase()
                      );
                      setDeleteModalData((prev) => ({
                        ...prev,
                        deleteParams: {
                          clientIndex: 0,
                          clientId: pageData?.objId_SettingOwner,
                          selectedLicenseType: item,
                          modalHeader: modalBody.header,
                          modalBody: modalBody.body,
                        },
                        show: true,
                      }));
                    }}
                    sections={pageData?.licenseTypesList ? [
                      {
                        title: "Client",
                        list: pageData?.licenseTypesList.filter((item) => !item?.Value?.toLowerCase().includes("prospect"))
                      },
                      {
                        title: "Prospect",
                        list: pageData?.licenseTypesList.filter((item) => item?.Value?.toLowerCase().includes("prospect"))
                      },
                    ] : []}
                    placeholder="Select"
                  />
                </div>
              </div>
            }];

            if (isDistributorView) {
              const fieldsWithoutLicense = allFields.filter(field => field.label !== 'License');
              
              fieldsWithoutLicense.push({
                label: 'Subscription',
                show: true,
                children: <SubscriptionSettingsLine currentPlan={pageData?.selectedLicenseType?.Value || "Disti Plan"} />
              });
              
              return fieldsWithoutLicense;
            }

    return allFields;
  }, [isDistributorView, pageData, companyDetails, industry, employee, hasSystemSettingsAccess, userDetails, handleOnChange]);

  const regionalSettingsFields = useMemo(() => {
    const allFields = [{
            label: 'Country',
            show: true,
            children: <div className="time-zone-drop-down timezone-drop">
            {pageData?.isCountryEnabled ? (
                <CompanyTimeZoneDropDown
                disabled={!hasSystemSettingsAccess}
                disabledIcon={!hasSystemSettingsAccess}
                fieldId={"objId"}
                fieldValue={"name"}
                header={"Choose option"}
                selected={country}
                placeholder="Choose..."
                onClick={(id, val) => {
                    handleOnChange(id, "SOcountry");
                    setCountry({ objId: id, name: val });
                }}
                data={countryList}
                />
            ) : (
                <div>
                <span className="name mr-3">
                    {country?.name}
                </span>
                </div>
            )}
            </div>
        },
          {
            label: 'Currency',
            value: pageData?.CurrencyCodeSymbol,
            show: true,
          },
        {
            label: 'Timezone',
            show: true,
            children: <div className="time-zone-drop-down timezone-drop">
            <CompanyTimeZoneDropDown
                disabled={!hasSystemSettingsAccess}
                disabledIcon={!hasSystemSettingsAccess}
                fieldId={"DDLId"}
                fieldValue={"DDLText"}
                selected={timezone}
                placeholder="Choose..."
                onClick={(id, val) => {
                handleOnChange(id, "SOtimezone");
                setTimezone({ DDLId: id, DDLText: val });
                }}
                data={companyDetails?.DDLMembers && companyDetails?.DDLMembers[2].DDLMemberList}
                menuClassname="timezone-menu"
            />
            </div>
        },
          {
            label: 'Language',
            show: true,
            children: <div className="d-flex align-items-center">
              <span className="name">English</span>
              <div className="tooltipx">
                <OverlayTrigger
                  placement="bottom"
                  trigger={["hover", "focus"]}
                  delay={{ show: 200, hide: 250 }}
                  overlay={
                    <Tooltip id={`tooltip-1365`}>
                      {'More language will be available soon...'}
                    </Tooltip>
                  }
                >
                  <img alt="" src="/images/settings-v2/info-icon.svg" className="details-arrow" />
                </OverlayTrigger>
              </div>
            </div>
          },
          {
            label: 'Localisation',
            value: pageData?.Localisation_Text,
            show: true,
          },
          {
            label: 'Taxes',
            show: true,
            onClick: () => {
              if (!hasSystemSettingsAccess) return;
              setTaxesModal(true);
            },
            children: <div>
              {hasSystemSettingsAccess ? (
                <img alt="" src="/images/chevron-right.svg" className="details-arrow" />
              ) : (
                <img width={14} height={14} alt="" src="/images/attack-surface/small-lock.svg" className="mx-2" />
              )}
            </div>
          }];

    if (isDistributorView) {
      allFields.push({
        label: '',
        show: true,
        itemStyle: 'temporary-support-access-item',
        children: <div className="temporary-support-access-note">
          For security purposes, Temporary Support Access must be requested by the MSP via their account
        </div>
      });
    }

    return allFields;
  }, [isDistributorView, pageData, country, countryList, timezone, companyDetails, hasSystemSettingsAccess, handleOnChange]);

  return (
    <div className="company-settings-v2">
      <CompanySettingsHeader
        selectedImage={selectedImage}
        accessStateValue={"AccessState_SystemSettings"}
        isView={isView}
        onImageChang={(e) => {
          if (e.target.files[0]) {
            const reader = new FileReader();
            reader.readAsDataURL(e.target.files[0]);
            reader.onload = function () {
              setSelectedImage(reader.result);
              showCropperModal();
            };
          }
        }}
        onImageRemove={() => {
          setSelectedImage("");
          CallToast("Logo removed", false, false, "v2style");
        }}
      />
        <hr className="m-0" />

        <SettingsPageBlock
          header={'Company Info'}
          data={companyInfoFields}
        />

        <SettingsPageBlock
        header={'Regional Settings'}
        data={regionalSettingsFields}
        />

        <SettingsPageBlock
          header={'Client Portal Support Contact'}
          data={[{
            label: 'Email',
            value: pageData?.ContactEmail,
            show: true,
            children: <img alt=""
              src={`/images/${hasSystemSettingsAccess ? 'chevron-right' : 'attack-surface/small-lock'}.svg`}
              className="details-arrow"
              width={hasSystemSettingsAccess && 14}
              height={hasSystemSettingsAccess && 14}
              style={{ marginRight: '7px' }}
            />,
            onClick: () => {
              if (hasSystemSettingsAccess) {
                setTextValueModal({
                  show: true,
                  title: "Change contact email",
                  inputLabel: "Email",
                  placeholder: "Enter email",
                  defaultValue: pageData?.ContactEmail,
                  handleOnChange: (value) => {
                    return updateEmailPhoneHandler({ email: value, phone: pageData?.PhoneNumber });
                  },
                  hideModal: () => {
                    setTextValueModal((prev) => ({ ...prev, show: false }));
                  },
                  validateValue: (value) => {
                    return stringUtils.isEmail(value);
                  },
                });
              }
            }
          },
          {
            label: 'Phone',
            value: pageData?.PhoneNumber,
            show: true,
            children: <img alt=""
              src={`/images/${hasSystemSettingsAccess ? 'chevron-right' : 'attack-surface/small-lock'}.svg`}
              className="details-arrow"
              width={hasSystemSettingsAccess && 14}
              height={hasSystemSettingsAccess && 14}
              style={{ marginRight: '7px' }}
            />,
            onClick: () => {
              if (hasSystemSettingsAccess) {
                setTextValueModal({
                  show: true,
                  title: "Change contact phone",
                  inputLabel: "Phone",
                  placeholder: "Enter phone",
                  defaultValue: pageData?.PhoneNumber,
                  handleOnChange: (value) => {
                    return updateEmailPhoneHandler({ email: pageData?.ContactEmail, phone: value });
                  },
                  hideModal: () => {
                    setTextValueModal((prev) => ({ ...prev, show: false }));
                  },
                  validateValue: (value) => {
                    return stringUtils.isPhoneNumber(value);
                  },
                  isLoading: isEmailPhoneLoading,
                });
              }
            }
          }]}
        />
        <TemporarySupportAccessModal
          show={showTemporarySupportAccessModal}
          hideModal={() => {
            setShowTemporarySupportAccessModal(false);
          }}
        />
        <ManageClientNotificationsModal
          show={manageEmalNotificationsModal}
          hideModal={() => {
            setManageEmalNotificationsModal(false);
          }}
          refresh={() => {
            getGeneralInfo();
          }}
        />
        <TaxesModal
          show={taxesModal}
          hideModal={() => {
            setTaxesModal(false);
          }}
          refresh={() => {
            getGeneralInfo();
          }}
          taxRates={taxRates}
        />
        <SendCopyMSPEmailsModal
          show={sendCopyMSPEmailsModal}
          hideModal={() => {
            setSendCopyMSPEmailsModal(false);
          }}
          emailsList={companyDetails?.MSPClientsEmails}
          refresh={() => {
            getGeneralInfo();
          }}
        />
        <SendCopyClientEmailsModal
          show={sendCopyClientEmailsModal}
          hideModal={() => {
            setSendCopyClientEmailsModal(false);
          }}
          emailsList={companyDetails?.SystemEmails}
          refresh={() => {
            getGeneralInfo();
          }}
        />
        <ChangeAddressModal
          show={addressModal}
          hideModal={hideAddressModal}
          handleOnChange={handleOnChange}
        />
        <UpdateNameModal
          show={updateNameModal}
          hideModal={hideUpdateNameModal}
          handleOnChange={handleOnChange}
        />
        <UpdateTextValueModal
          {...textValueModal}
          isLoading={isEmailPhoneLoading}
        />
        <ImageCropperModal
          show={cropperModal}
          hideModal={hideCropperModal}
          profileImage={selectedImage}
          setProfileImage={setSelectedImage}
          uploadType={1}
          clientId={clientId}
        />
        <CustomDeleteModal
          show={deleteModalData.show}
          deleteType={"switchInvoicesTabInMspTechSpend"}
          deleteParams={deleteModalData.deleteParams}
          deleteFunction={(data) => {
            let updated_data = pageData;
            updated_data.selectedLicenseType = { ...data.selectedLicenseType };
            updated_data.companyType = data.selectedLicenseType?.Value?.toLowerCase().includes("prospect") ? 'Prospect' : 'Client'
            setPageData(updated_data);
            updateClientLicence({ clientId: data?.clientId, Key: data.selectedLicenseType.Key });
          }}
          hideModal={() => {
            setDeleteModalData((prev) => ({ ...prev, show: false }));
          }}
          deleteButtonClass={"hg-blue-btn"}
          deleteButtonText={"Continue"}
          deleteHeaderText={deleteModalData?.deleteParams?.modalHeader}
          customBody={
            <>
              <div className="mt-2">
                {deleteModalData?.deleteParams?.modalBody}
              </div>
            </>
          }
        />
    </div>
  )
}

export default CompanySettings;
